// src/data/services.js
const Services = [
  'Managed IT Services',
  'Cybersecurity Services',
  'Hardware as a Service',
  'Disaster Recovery',
  'Cloud Solutions',
  'IT Consulting',
  'vCIO Services',
  'Network Security',
  'Hosted Private Cloud',
  'Managed Print Services',
  'Robotic Process Automation',
];

export default Services;
